import React from 'react';
import { Paper, Stack, Group, Title, Text, Badge, ThemeIcon } from '@mantine/core';
import { IconAffiliate, IconExclamationMark, IconPlaystationCircle, IconRadar, IconTag } from '@tabler/icons';
import { Link } from 'react-router-dom';
import { Technology } from '../../../backend/models/technology';
import { BadgeDecorator } from '.';

type PropType = { technology: Technology; invalidRingName: boolean; invalidSectionName: boolean };

const TechnologyCard = (props: PropType) => {
  const { technology, invalidRingName, invalidSectionName } = props;
  return (
    <Link
      key={technology.name}
      to={`/technology/${encodeURIComponent(technology.name)}`}
      style={{ textDecoration: 'none' }}
    >
      <Paper
        shadow="xs"
        p="md"
        sx={(theme) => ({
          backgroundColor: invalidRingName || invalidSectionName ? theme.colors.red[1] : 'white',
          height: '100%',
          transition: 'box-shadow 100ms ease, transform 100ms ease',
          '&:hover': {
            boxShadow:
              '0 1px 3px rgb(0 0 0 / 5%), rgb(0 0 0 / 5%) 0px 20px 25px -5px, rgb(0 0 0 / 4%) 0px 10px 10px -5px',
            transform: 'scale(1.01)',
          },
        })}
      >
        <Stack>
          <Title order={2}>{technology.name}</Title>
          <Stack spacing={'xs'}>
            <Group position="left">
              <ThemeIcon color={invalidSectionName ? 'red' : 'avensia-blue'} size={24} radius="xl">
                {invalidSectionName ? <IconExclamationMark size={16} /> : <IconRadar size={16} />}
              </ThemeIcon>
              <Text fw={500}>Section: </Text>
              <Text fw={400}>{technology.section?.name}</Text>
            </Group>
            <Group position="left">
              <ThemeIcon color={invalidRingName ? 'red' : 'avensia-blue'} size={24} radius="xl">
                {invalidRingName ? <IconExclamationMark size={16} /> : <IconPlaystationCircle size={16} />}
              </ThemeIcon>
              <Text fw={500}>Ring: </Text>
              <Text fw={400}>{technology.ring?.name}</Text>
            </Group>
            {technology.tags && technology.tags.length > 0 && (
              <Group noWrap align={'flex-start'}>
                <ThemeIcon color={'avensia-blue'} size={24} radius="xl">
                  <IconTag size={16} />
                </ThemeIcon>
                <Group>
                  <Text fw={500}>Tags: </Text>
                  {technology.tags.slice(0, 3).map((tag) => (
                    <Badge key={tag.id} color={'cyan'} styles={BadgeDecorator}>
                      {tag.name}
                    </Badge>
                  ))}
                  {technology.tags.length > 3 && (
                    <Badge key={'more'} color={'cyan'}>{`+${technology.tags.length - 3}`}</Badge>
                  )}
                </Group>
              </Group>
            )}
            {technology.clients && technology.clients.length > 0 && (
              <Group noWrap align={'flex-start'}>
                <ThemeIcon color={'avensia-blue'} size={24} radius="xl">
                  <IconAffiliate size={16} />
                </ThemeIcon>
                <Group>
                  <Text fw={500}>Clients: </Text>
                  {technology.clients.slice(0, 3).map((client) => (
                    <Badge key={client.id} color={'orange'} styles={BadgeDecorator}>
                      {client.name}
                    </Badge>
                  ))}
                  {technology.clients.length > 3 && (
                    <Badge key={'more'} color={'orange'}>{`+${technology.clients.length - 3}`}</Badge>
                  )}
                </Group>
              </Group>
            )}
          </Stack>
        </Stack>
      </Paper>
    </Link>
  );
};

export default TechnologyCard;
